import React, { useState } from 'react'
import { Navbar, Offcanvas } from 'react-bootstrap'
import { appShellPermissions } from '@ztechapps/common.contract'
import { useRole } from '@ztechapps/common.hook'
import { HorizontalStack, ShowOnlyOnScreenSize } from '@ztechapps/webui.util'
import { DbRestoreButton } from '@ztechapps/webui.page'
import { BusyButton } from '@ztechapps/webui.button'
import { usePageLifecycle } from '@ztechapps/common.hook'
import Profile from './profile/profile'
import { QuickCreate } from './quick-create'
import { LogoWithName } from '../../components/logo/LogoWithName'
import { MenuBar } from './menu-bar'
import { MOBILE_BREAKING_POINT } from '../../config/constants'
import { NotificationBell } from './notification'
import { GlobalSearchWrapper } from './GlobalSearchWrapper'
import { GlobalShortcuts } from './GlobalShortcuts'

export default function Header() {
  return (
    <Navbar className="header" expand="lg" fixed="top">
      <Navbar.Brand>
        <LogoWithName />
      </Navbar.Brand>

      <ShowOnlyOnScreenSize size={'desktop'} breakingPoint={MOBILE_BREAKING_POINT}>
        <TopBarContent />
      </ShowOnlyOnScreenSize>

      <ShowOnlyOnScreenSize size={'mobile'} breakingPoint={MOBILE_BREAKING_POINT}>
        <OffCanvasMenu />
      </ShowOnlyOnScreenSize>
    </Navbar>
  )
}

const OffCanvasMenu = () => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  usePageLifecycle(null, handleClose)

  return (
    <div className="me-2">
      <BusyButton icon="bars" onClick={handleShow} />

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <LogoWithName />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <TopBarContent />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  )
}

const TopBarContent = () => {
  const { hasRole: isAdmin } = useRole({ roleName: appShellPermissions.admin.canAccess.value })

  return (
    <>
      <MenuBar />
      <div className="mx-3 flex-grow-1">
        <GlobalSearchWrapper />
      </div>
      <nav className="ms-auto">
        <HorizontalStack gap={2} className="align-items-center">
          <NotificationBell />
          <DbRestoreButton
            disabledReason={isAdmin ? undefined : 'You need the admin permission to restore the database.'}
          />
          <GlobalShortcuts />
          <QuickCreate />
          <Profile />
        </HorizontalStack>
      </nav>
    </>
  )
}
